import { parseCodeSearchQuery } from '#/lib/code-search'

export interface RepositorySearchScope {
  owner: string
  repo: string
  ref?: string | null
}

export interface ParsedSearchQuery {
  query: string
  scope: { owner: string; repo: string } | null
  hasSearchTerms: boolean
  error: string | null
}

export function repositorySearchPrefix(scope: RepositorySearchScope): string {
  return `repo:${scope.owner}/${scope.repo}`
}

export function initialSearchQuery(scope: RepositorySearchScope | null): string {
  return scope ? `${repositorySearchPrefix(scope)} ` : ''
}

export function parseSearchQuery(value: string): ParsedSearchQuery {
  const query = value.trim()
  const parsed = parseCodeSearchQuery(query)
  const repoAtom = parsed.atoms.find((atom) => atom.qualifier === 'repo')
  const repoParts = repoAtom?.value.split('/') ?? []
  const scope =
    repoParts.length === 2 && repoParts[0] && repoParts[1]
      ? { owner: repoParts[0], repo: repoParts[1] }
      : null

  return {
    query,
    scope,
    hasSearchTerms: parsed.atoms.some((atom) => atom.qualifier !== 'repo'),
    error: parsed.error,
  }
}

export function fileSearchHref(result: {
  owner: string
  repo: string
  ref: string
  path: string
}): string {
  const path = result.path
    .split('/')
    .filter(Boolean)
    .map((segment) => encodeURIComponent(segment))
    .join('/')
  return `/${encodeURIComponent(result.owner)}/${encodeURIComponent(result.repo)}/blob/${encodeURIComponent(result.ref)}/${path}`
}
